<template>
  <app-modal ref="modal">
    <div class="change-volume">
      <h2 class="change-volume__title">{{ $t('productSubpage.doYouWantToChangeVolume') }}</h2>

      <i18n
        class="change-volume__body u-typography-helvetica u-text u-text--s"
        tag="p"
        path="productSubpage.changeVolumeTo"
      >
        <b class="u-typography-helvetica u-text u-text--s u-text--link">{{
          formatSize(previousSize)
        }}</b>
        <b class="u-typography-helvetica u-text u-text--s u-text--link">{{
          formatSize(nextSize)
        }}</b>
      </i18n>

      <div class="change-volume__actions actions">
        <u-button v-modal-submit class="actions__button">{{ $t('action.change') }}</u-button>
        <u-button v-modal-cancel class="actions__button" kind="secondary">{{
          $t('action.cancel')
        }}</u-button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { UButton } from 'universkin-shared';

import AppModal from '@/components/common/AppModal.vue';

import { getSizeUnits, getSizeValue } from '@/models/core/values';

export default {
  name: 'DoYouWantToChangeVolumeModal',
  components: { AppModal, UButton },
  props: {
    previousSize: {
      type: Object,
      default: null
    },
    nextSize: {
      type: Object,
      default: null
    }
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    },
    formatSize(size) {
      if (!size) {
        return '';
      }

      const value = getSizeValue(size);
      const units = getSizeUnits(size);

      return `${value}${units}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors.scss';

.change-volume {
  padding: 48px;
  width: 90vw;
  max-width: 660px;
  background-color: white;
  border-radius: 10px;
  text-align: center;

  &__title {
    font-family: var(--u-font-family-Helvetica);
    font-weight: 450;
    font-size: 24px;
    line-height: 30px;
    color: $tuatara-color;
    margin-bottom: 32px;
  }

  &__body {
    margin-bottom: 32px;
  }

  &__actions {
    width: 100%;
  }
}

.actions {
  &__button {
    width: 80%;
    margin: 0 auto;

    &:first-child {
      margin-bottom: 16px;
    }
  }
}

@media (min-width: 600px) {
  .actions {
    display: flex;
    flex-direction: row-reverse;

    &__button {
      flex: 1 1 0;

      &:first-child {
        margin-left: 16px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
